const module = { name: 'fd-header/searchAutocomplete', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango_dropdown as dropdown } from 'base-libraries';



import { Fandango_sanitizer as sanitizer } from 'require-core';



const KeyCodes = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: 'Space',
    TAB: 'Tab',
}


const Defaults = {
    CATEGORY_SELECTOR: '.js-fan-autocomplete-category',
    CLOSE_BTN_STYLE: 'global-search__results-close-btn',
    DROPDOWN_STYLE: 'fan-autocomplete-results',
    GO_BTN: '#global-header-go-btn',
    LOADING_STYLE: 'is-loading',
    HAS_RESULTS_STYLE: 'has-results',
    INPUT_SELECTOR: '#global-header-search-input',
    MAIN_CONTENT_SKIP_LINK: '#main-content-skip-link',
    OPEN_PARENT: 'global-header-search-input',
    RATE_LIMIT_FN: 'debounce',
    RATE_LIMIT_WAIT: 200,
    RELATIVE_PARENT: '.js-fd-header-nav-bar-search-input',
    RESULT_LINK: '.js-fan-autocomplete-link',
    SEE_MORE: '#fan-autocomplete-see-more',
    STATUS_SPAN: '#global-header-search-status',
}


let $searchResultsDropdown
function closeDropdown() {
    $searchResultsDropdown && $searchResultsDropdown.length && $searchResultsDropdown[0].close();
}
function init(ele, opts) {
    opts = $.extend(Defaults, opts);
    const $autocomplete = $(ele);
    const $input = $autocomplete.find(opts.INPUT_SELECTOR);
    const renderCache = {};
    const searchTermCache = {};
    let mostRecentSearchTerm = '';
    function reset() {
        $autocomplete.removeClass(opts.LOADING_STYLE);
        $input.removeClass(opts.HAS_RESULTS_STYLE);
        $input.attr('tabindex', 0);
        $(opts.STATUS_SPAN).text('');
        closeDropdown();
    }
    function attachKeyboardA11y() {
        const $categories = $(opts.CATEGORY_SELECTOR);
        $input.on('keydown', (e) => {
            if (e.code !== KeyCodes.ARROW_DOWN) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $input.attr('tabindex', -1);
            $($(opts.RESULT_LINK)[0])
                .attr('tabindex', 0)
                .trigger('focus');
        });
        $(opts.RESULT_LINK).on('keydown', (e) => {
            const $focusedElement = $(e.currentTarget);
            const $focusedParent = $($focusedElement.parent());
            e.preventDefault();
            e.stopPropagation();
            if (e.code === KeyCodes.ENTER || e.code === KeyCodes.SPACE) {
                $(e.currentTarget).click();
            }
            if (e.code !== KeyCodes.ARROW_UP && e.code !== KeyCodes.ARROW_DOWN) {
                return;
            }
            if (e.code === KeyCodes.ARROW_UP) {
                $focusedElement
                    .attr('tabindex', -1);
                const prevElements = $focusedParent.prev().children();
                if (!prevElements.length) {
                    if ($categories.length > 1) {
                        const $prevCategoryResults = $focusedParent.parents(opts.CATEGORY_SELECTOR).prev().find(opts.RESULT_LINK);
                        if ($prevCategoryResults.length) {
                            return $($prevCategoryResults).last()
                                .attr('tabindex', 0)
                                .trigger('focus');
                        }
                    }
                    return $input
                        .attr('tabindex', 0)
                        .trigger('focus');
                }
                $(prevElements[0])
                    .attr('tabindex', 0)
                    .trigger('focus');
            }
            else {
                $focusedElement
                    .attr('tabindex', -1);
                const nextElements = $focusedParent.next().children();
                if (!nextElements.length) {
                    if ($categories.length > 1) {
                        const $nextCategoryResults = $focusedParent.parents(opts.CATEGORY_SELECTOR).next().find(opts.RESULT_LINK);
                        if ($nextCategoryResults.length) {
                            return $($nextCategoryResults[0])
                                .attr('tabindex', 0)
                                .trigger('focus');
                        }
                    }
                    return $(opts.SEE_MORE)
                        .attr('tabindex', 0)
                        .trigger('focus');
                }
                $(nextElements[0])
                    .attr('tabindex', 0)
                    .trigger('focus');
            }
        });
        $(opts.SEE_MORE).on('keydown', (e) => {
            if (e.code !== KeyCodes.ARROW_UP) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $(e.currentTarget).attr('tabindex', -1);
            $($(opts.RESULT_LINK).last())
                .attr('tabindex', 0)
                .trigger('focus');
        });
        $(opts.GO_BTN).on('focus', () => $searchResultsDropdown.addClass('hide'));
        $(opts.MAIN_CONTENT_SKIP_LINK).on('focus', () => $searchResultsDropdown.addClass('hide'));
        $(opts.GO_BTN).on('keydown', (e) => {
            if (e.code !== KeyCodes.TAB || !e.shiftKey) {
                return;
            }
            $searchResultsDropdown.removeClass('hide');
        });
        $(opts.MAIN_CONTENT_SKIP_LINK).on('keydown', (e) => {
            if (e.code !== KeyCodes.TAB) {
                return;
            }
            $searchResultsDropdown.removeClass('hide');
        });
    }
    function display(markup) {
        closeDropdown();
        dropdown.openAsync(markup, {
            dropdownStyle: opts.DROPDOWN_STYLE,
            includeCloseBtn: false,
            name: 'globalHeaderSearchResults',
            openParent: opts.OPEN_PARENT,
            relativeParent: opts.RELATIVE_PARENT,
            trapFocus: false,
            closeCB() {
                $input.attr('tabindex', 0);
            },
        }, (dropdown) => {
            $searchResultsDropdown = $(dropdown);
            $input.addClass(opts.HAS_RESULTS_STYLE);
            $(opts.RESULT_LINK).on('click', (e) => {
                if (e.target !== document.activeElement) {
                    return;
                }
                e.preventDefault();
                window.location = sanitizer.url(e.currentTarget.dataset.url);
            });
            attachKeyboardA11y();
            const count = $(opts.RESULT_LINK).length;
            $(opts.STATUS_SPAN).text(count ? `${count} suggestion${count !== 1 ? 's' : ''} found` : 'No suggestions found');
            $autocomplete.removeClass(opts.LOADING_STYLE);
        });
    }
    function handleInput(e) {
        if (e.code === KeyCodes.TAB) {
            return;
        }
        const searchTerm = $input.val().trim().toLowerCase();
        if (!searchTerm.length || (e && e.code === KeyCodes.ESCAPE)) {
            return reset();
        }
        if (renderCache[searchTerm]) {
            mostRecentSearchTerm = searchTerm;
            return display(renderCache[searchTerm]);
        }
        if (searchTermCache[searchTerm]) {
            return;
        }
        $autocomplete.addClass(opts.LOADING_STYLE);
        searchTermCache[searchTerm] = searchTerm;
        mostRecentSearchTerm = searchTerm;
        let url;
        if (links.napiAutocompleteDesktopSearch) {
            url = links.napiAutocompleteDesktopSearch();
        }
        else if (links.snapiAutocompleteDesktopSearch) {
            url = links.snapiAutocompleteDesktopSearch();
        }
        else {
            debugLog.error(module.name, 'no search function found');
            return;
        }
        xhr.ajax({
            url,
            method: 'GET',
            data: { search: searchTerm },
        })
            .done((results) => {
            if (searchTerm !== mostRecentSearchTerm) {
                return;
            }
            if (!results || !results.resultsByType) {
                return reset();
            }
            renderCache[searchTerm] = opts.render(results);
            display(renderCache[searchTerm]);
        })
            .fail(reset);
    }
    $input
        .on('focus', handleInput)
        .on('keyup', $[opts.RATE_LIMIT_FN](opts.RATE_LIMIT_WAIT, handleInput));
}
module.exports = {
    init,
};
export default module.exports;